import MessageHistory from "./MessageHistory";

export default MessageHistory;
